<template lang="">
  <div>
    <TableLeadCategory class="ma-4" />
    <LabelExistingMatches class="ma-4" />
  </div>
</template>
<script>
export default {
  name: "ConfigRealEstateGroup",
  components: {
    LabelExistingMatches: () => import("./LabelExistingMatches.vue"),
    TableLeadCategory: () => import("./LeadCategory/Table.vue")
  }
};
</script>
<style lang=""></style>
